import Record from '../Record'

export default class OneTimeDebit extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (id = null) {
		if (id == null) {
			// Create record
			return new OneTimeDebit({
				id: null,
				company_id: null,

				node_id: null,
				node_type: null,

				debit_type: null,
				recurring: 0,

				start_d: null,
				end_d: null,

				amount: null,
				dividend: 0
			})
		}
	}

	validation_schema = {
		debit_type: [ 'required' ],
		amount: [ 'required' ],
		dividend: [ 'required' ]
	}
}
